export default __webpack_public_path__ + "static/button-label-do-light-fc0ac7a707a8a7d0843a3370072c0bb6.png";